define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class ClientService
     */
    function ClientService($root, $q, $log, clientProvider, $indexedDB, $filter, commonService, localStorageService) {
        var self = this;
        var DIRTY_CLIENT_ID_KEY = 'user.clients.dirtyIds';
        var SECTORS_KEY = 'user.clients.sectors';

        /**
         * Get sectors list
         * @return {Array}
         */
        self.getSectors = function getSectors() {
            var sectors = localStorageService.get(SECTORS_KEY);

            if (!sectors) {
                sectors = [];
            }
            else {
                sectors = JSON.parse(sectors);
            }

            return sectors;
        };

        /**
         * Add a sector to the sectors list
         * @param {int} sector
         */
        self.addSector = function addSector(sector) {
            var sectors = self.getSectors();

            var found = false;
            for (var i = 0; i < sectors.length; i++) {
                if (sectors[i] === sector) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                sectors.push(sector);
                localStorageService.set(SECTORS_KEY, JSON.stringify(sectors));
            }
        };

        self.clearSectors = function clearSectors() {
            localStorageService.set(SECTORS_KEY, JSON.stringify([]));
        };

        /**
         * Clear the
         * @return {Promise}
         */
        self.clearLocalClients = function clearLocalClients() {
            if (_getDirtyids().length) {
                return $q.reject({ message: 'Des clients ne sont pas synchronisés. Vous ne pouvez pas vider la base' });
            }

            return $indexedDB.openStore('Clients', function(objectStore) {
                return objectStore.clear();
            });
        };

        /**
         * Delete a local client identified by its _id property
         * @param  {String} _id
         * @return {Promise}
         */
        function _deleteLocalClient(_id) {
            return $indexedDB.openStore('Clients', function(objectStore) {
                return objectStore.delete(_id);
            });
        }

        /**
         * Download clients and store them into the browser
         * @param  {Array} sectors
         * @return {Promise}
         */
        self.downloadClients = function downloadClients(sectors) {
            return self.clearLocalClients(sectors.join(',')).then(function() {
                return clientProvider.downloadSectors(sectors).then(function(clients) {
                    return self.saveLocally(clients);
                });
            });
        };

        /**
         * Save the searched clients locally
         * @param  {Array} clients
         * @return {Promise}
         */
        self.saveLocally = function saveLocally(clients) {
            return $indexedDB
                .openStore('Clients', function(objectStore) {
                    return objectStore.getAll().then(function(localClients) {
                        return localClients;
                    });
                })
                .then(function(localClients) {
                    var found;
                    var promise;
                    var promises = [];
                    for (var i = clients.length - 1; i >= 0; i--) {
                        for (var j = localClients.length - 1; j >= 0; j--) {
                            if (clients[i].storeId === localClients[j].storeId) {
                                promise = _deleteLocalClient(localClients[j]._id);
                                promises.push(promise);
                                break;
                            }
                        }

                        if (!Number.isInteger(clients[i].id)) {
                            clients[i].id = clients[i].storeId;
                        }

                        clients[i]._id = btoa(clients[i].id + clients[i].storeId);
                    }

                    return $q.all(promises).then(function() {
                        return $indexedDB.openStore('Clients', function(objectStore) {
                            return objectStore.upsert(clients);
                        });
                    });
                });
        };

        /**
         * Get the local clients according to a seacrh (only lastName)
         * @param  {String} search
         * @return {Promise}
         */
        function _getAllLocally(search) {
            return $indexedDB.openStore('Clients', function(objectStore) {
                return objectStore.getAll().then(function(res) {
                    $log.info('GET local clients');
                    return $filter('filter')(res, { $: search });
                });
            });
        }

        /**
         * Search a client
         * @param  {String} search NIM or lastname
         * @return {Promise}
         */
        self.searchClient = function searchClient(search) {
            var d = $q.defer();

            if (!$root.online) {
                return _getAllLocally(search);
            }

            clientProvider.searchClient(search).then(function(clients) {
                self.saveLocally(clients).then(function() {
                    d.resolve(clients);
                });
            }, d.reject.bind(d));

            return d.promise;
        };

        /**
         * Return the map objet
         * @return {object}
         */
        self.getClientObject = function getClientObject() {
            return {
                id: null,
                storeId: null,
                emblem: null,
                corporateName: null,
                IBAN: null,
                codeBic: null,
                firstName: null,
                lastName: null,
                addressStreet: null,
                addressPostalCode: null,
                addressCity: null,
                mobilePhone: null,
                storePhone: null,
                SIRET: null,
                RCS: null,
                storeType: {
                    id: null,
                    code: null,
                    label: null
                },
                storeActivity: null,
                storeActivityId: null,
                storeActivityCode: null,
                storeActivityLabel: null,
                email: null,
                NIM: null
            };
        };

        /**
         * Get the list of dirtyIds
         * @return {Array}
         */
        function _getDirtyids() {
            var dirtyIds = localStorageService.get(DIRTY_CLIENT_ID_KEY);

            if (!dirtyIds) {
                dirtyIds = [];
            }
            else {
                dirtyIds = JSON.parse(dirtyIds);
            }

            return dirtyIds;
        }

        /**
         * Add new local client to the offline created clients list
         * @param {Object} idAndStoreId
         */
        function _addDirtyClientId(idAndStoreId) {
            var dirtyIds = _getDirtyids();

            var found = false;
            for (var i = 0; i < dirtyIds.length; i++) {
                if (dirtyIds[i].id === idAndStoreId.id && dirtyIds[i].storeId === idAndStoreId.storeId) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                dirtyIds.push(idAndStoreId);
                localStorageService.set(DIRTY_CLIENT_ID_KEY, JSON.stringify(dirtyIds));
            }
        }

        /**
         * Create or update a client
         * @param  {Object} data
         * @return {Promise}
         */
        self.createUpdate = function createUpdate(data) {
            var d = $q.defer();

            if (!$root.online) {
                // Local created client
                if (data.id === null) {
                    data.id = commonService.generateUID();
                }

                return self.updateClient(data).then(function(client) {
                    _addDirtyClientId({ id: client.id, storeId: data.storeId });
                    return client;
                });
            }

            if (!Number.isInteger(data.id)) {
                data.id = null;
            }

            return clientProvider.createUpdate(data).then(function(client) {
                return self.updateClient(client).then(function() {
                    return client;
                });
            });
        };

        /**
         * Get local client by _id
         * @param  {String} id
         * @return {Promise}
         */
        function _getLocalClient(id, storeId) {
            var _id = btoa(id + storeId);
            return $indexedDB.openStore('Clients', function(objectStore) {
                return objectStore.find(_id);
            });
        }

        /**
         * Update dirty local client with the correct data
         * @param  {String} id
         * @param  {String} storeId
         * @param  {Object} client
         * @return {Promise}
         */
        function _updateDirtyLocalClientAndOrders(id, storeId, client) {
            return $indexedDB
                .openStore('Clients', function(objectStore) {
                    return objectStore.delete(btoa(id + storeId)).then(function() {
                        return client;
                    });
                })
                .then(function(client) {
                    return self.updateClient(client).then(function(client) {
                        // Update the orders created with the local client
                        return $indexedDB.openStore('Orders', function(objectStore) {
                            return objectStore.getAll().then(function(orders) {
                                for (var i = 0; i < orders.length; i++) {
                                    if (orders[i].client.id === id) {
                                        orders[i].client.id = client.id;
                                        objectStore.upsert(orders[i]);
                                    }
                                }
                                return client;
                            });
                        });
                    });
                });
        }

        /**
         * Delete dirty id
         * @param  {String} id
         */
        function _deleteDirtyId(id, storeId) {
            var dirtyIds = _getDirtyids();
            var indexDirtyId = -1;

            for (var i = 0; i < dirtyIds.length; i++) {
                if (dirtyIds[i].id === id && dirtyIds[i].storeId === storeId) {
                    indexDirtyId = i;
                    break;
                }
            }

            if (indexDirtyId === -1) {
                return;
            }

            dirtyIds.splice(indexDirtyId, 1);
            localStorageService.set(DIRTY_CLIENT_ID_KEY, JSON.stringify(dirtyIds));
        }

        /**
         * Send the dirty clients to the webservice
         * 1 ) Send to the webservice
         * 2 ) Update the local data
         * 3 ) Remove the dirty id from the list
         * @return {Promise}
         */
        self.sendDirtyClients = function sendDirtyClients() {
            var dirtyIds = _getDirtyids();
            var dirtyId, promise;
            var promises = [];

            if (!dirtyIds.length) {
                var d = $q.defer();
                d.resolve();
                return d.promise;
            }

            for (var i = 0; i < dirtyIds.length; i++) {
                promise = _getLocalClient(dirtyIds[i].id, dirtyIds[i].storeId)
                    .then(function(localClient) {
                        dirtyId = localClient.id;

                        if (!localClient) {
                            $q.resolve();
                        }

                        // Remembler that a local client has a generated String id
                        if (!Number.isInteger(localClient.id)) {
                            localClient.id = null;
                        }

                        return { dirtyId: dirtyId, localClient: localClient };
                    })
                    .then(function(res) {
                        return clientProvider.createUpdate(res.localClient).then(function(client) {
                            $log.info("Local client '" + res.dirtyId + "' has been sended");

                            if (!res.localClient.id) {
                                $log.info('New id : ' + client.id);
                            }

                            return _updateDirtyLocalClientAndOrders(res.dirtyId, res.localClient.storeId, client).then(
                                function() {
                                    $log.info("Local client '" + res.dirtyId + "' has been locally updated");
                                    _deleteDirtyId(res.dirtyId, client.storeId);
                                }
                            );
                        });
                    });

                promises.push(promise);
            }

            return $q.all(promises);
        };

        /**
         * Update local client
         * @param {Object}
         * @return {Promise}
         */
        self.updateClient = function(client) {
            client._id = btoa(client.id + client.storeId);
            return $indexedDB.openStore('Clients', function(objectStore) {
                return objectStore.upsert(client).then(function() {
                    return client;
                });
            });
        };

        self.clearCache = function clearCache() {
            localStorageService.set(SECTORS_KEY, JSON.stringify([]));
            localStorageService.set(DIRTY_CLIENT_ID_KEY, JSON.stringify([]));

            return $indexedDB.openStore('Clients', function(objectStore) {
                return objectStore.clear();
            });
        };

        return self;
    }

    ClientService.$inject = [
        '$rootScope',
        '$q',
        '$log',
        'client',
        '$indexedDB',
        '$filter',
        'commonService',
        'localStorageService'
    ];

    angular.module('app.bdc.list.clientService', []).factory('clientService', ClientService);
});
